module.exports = __webpack_public_path__ + "static/img/3.9b03509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/6/3.png
// module id = W/Ef
// module chunks = 1